import { render, staticRenderFns } from "./AddApprovedDns.vue?vue&type=template&id=0303e512&"
import script from "./AddApprovedDns.vue?vue&type=script&lang=js&"
export * from "./AddApprovedDns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports